// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__mmMaW","avatarImage":"avatar_avatarImage__DdZs3","noImage":"avatar_noImage__m7qZ_","fade-in":"avatar_fade-in__MUMbA"};